/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { themeStyleHelper, classStyleHelper } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// SECTION
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	section: {

		// ----- colors ----- //
		// generates classes for every color in the theme ".color-(uniqueColor)"
		extend: [classStyleHelper.direction, classStyleHelper.align, themeStyleHelper(theme, 'color', (theme, uniqueColor) => {
			return {
				background: theme.color[uniqueColor].medium.swatch,
				color: theme.color[uniqueColor].medium.contrast
			}
		})]
	}
});